// src/components/Onboarding.jsx
import React, { useState } from "react";
import { Routes, Route, useNavigate, useLocation, Navigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Plan from "./steps/Plan";
import ValidateEmail from "./steps/ValidateEmail";
import CustomerDetails from "./steps/CustomerDetails";
import OrderProcessing from "./steps/OrderProcessing";
import Error from "./Error";
import Confirm from "./steps/Confirm";
import { default as content } from '../content/en'

const initialCustomerSelections = {
  "Select Plan": {
    stepDescription: "",
    stepDetails: "",
  },
  "Validate Email": { stepDescription: "", stepDetails: "" },
  "Your Details": { stepDescription: "", stepDetails: "" },
  "Provide Payment": { stepDescription: "", stepDetails: "" },
  "Download app": { stepDescription: "", stepDetails: "" },
};

export default function Onboarding({ basketRefId, affilliateRef, promoCode, planSelected }) {
  const [customerSelections, setCustomerSelections] = useState(initialCustomerSelections);
  const [userEmail, setUserEmail] = useState("");
  const [emailValidated, setEmailValidated] = useState(false);
  const [customerDetails, setCustomerDetails] = useState(undefined);
  const [userSimType, setUserSimType] = useState("physical");
  const [userPlan, setUserPlan] = useState("");
  const [planPrice, setPlanPrice] = useState("");
  const [basket, setBasket] = useState(null);
  const [simType, setSimType] = useState("esim");
  const navigate = useNavigate();
  const location = useLocation();
  const [orderRef, setOrderRef] = useState("");
  const [preSelectedPlan, setPreSelectedPlan] = useState(planSelected);

  // Helper to go to next/prev step by path
  const stepPaths = [
    "/plans",
    "/validate",
    "/your-details",
    "/processing",
    "/confirmation"
  ];
  const currentStepIdx = stepPaths.findIndex((p) => location.pathname === p);
  const next = () => {
    if (currentStepIdx < stepPaths.length - 1) navigate(stepPaths[currentStepIdx + 1]);
  };
  const prev = () => {
    if (currentStepIdx > 0) navigate(stepPaths[currentStepIdx - 1]);
  };

  return (
    <div className="content">
      <div>
        <Routes>
          {/* switch the below lines around to change between the root URL and /plans */}
          {/* <Route path="/" element={ */}
          <Route path="/plans" element={
            <Plan
              next={next}
              prev={prev}
              setUserPlan={setUserPlan}
              planPrice={planPrice}
              setPlanPrice={setPlanPrice}
              customerSelections={customerSelections}
              setCustomerSelections={setCustomerSelections}
              basket={basket}
              setBasket={setBasket}
              simType={simType}
              setSimType={setSimType}
              preSelectedPlan={preSelectedPlan}
            />
          } />
          <Route path="/validate" element={
            <ValidateEmail
              next={next}
              prev={prev}
              setUserEmail={setUserEmail}
              userEmail={userEmail}
              emailValidated={emailValidated}
              setEmailValidated={setEmailValidated}
              userPlan={userPlan}
              planPrice={planPrice}
              customerSelections={customerSelections}
              setCustomerSelections={setCustomerSelections}
              basket={basket}
              affilliateRef={affilliateRef}
              setPreSelectedPlan={setPreSelectedPlan}
            />
          } />
          <Route path="/your-details" element={
            <CustomerDetails
              next={next}
              prev={prev}
              userEmail={userEmail}
              userPlan={userPlan}
              setUserPlan={setUserPlan}
              planPrice={planPrice}
              setPlanPrice={setPlanPrice}
              customerSelections={customerSelections}
              setCustomerSelections={setCustomerSelections}
              basket={basket}
              setBasket={setBasket}
              simType={simType}
              setSimType={setSimType}
              customerDetails={customerDetails}
              affilliateRef={affilliateRef}
              setCustomerDetails={setCustomerDetails}
              promoCode={promoCode}
            />
          } />
          <Route path="/processing" element={
            <OrderProcessing
              next={next}
              prev={prev}
              userEmail={userEmail}
              userSimType={userSimType}
              userPlan={userPlan}
              planPrice={planPrice}
              customerSelections={customerSelections}
              setCustomerSelections={setCustomerSelections}
              basketRefId={basketRefId}
              setOrderRef={setOrderRef}
            />
          } />
          <Route path="/confirmation" element={
            <Confirm
              next={next}
              prev={prev}
              userEmail={userEmail}
              userSimType={userSimType}
              userPlan={userPlan}
              planPrice={planPrice}
              customerSelections={customerSelections}
              setCustomerSelections={setCustomerSelections}
              orderRef={orderRef}
            />
          } />
          <Route path="/error" element={
            <Error
              message={content.error.genericErrorMessage}
              code={content.error.genericErrorCode}
            />
          } />
          {/* Redirect any unknown paths to the plans step which is currently the URL '/plans' 
                Switch the statements below around to start using the root URL instead */}
          <Route path="*" element={<Navigate to="/plans" replace />} />
          {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
        </Routes>
      </div>
    </div>
  );
}
